export default `
I always hate going to this part... it's full of 'em. Rats. Robots.
All things bad.
`;
